export default __webpack_public_path__ + "static/media/meme.72481426.png";